// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts'
// 引入饼图
import 'echarts/lib/chart/pie'
// 引入折线图
import 'echarts/lib/chart/line'
// 引入悬浮文字
import 'echarts/lib/component/tooltip'
// 引入图例
import 'echarts/lib/component/legend'
// 引入标题
import 'echarts/lib/component/title'

export default echarts;